import { Injectable } from '@angular/core';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  siteKeyV3:string = env.recaptchaSiteKeyV3;
  resolvedResponseV3_loadContactInformation: string;
  resolvedResponseV3_submitClaim: string;
  resolvedResponseV3_checkPreExisting: string;
  resolvedResponseV3_loadClaimPageStatusData: string;
  resolvedResponseV3_loadClaimPagePaymentData: string;
  resolvedResponseV3_isGDPRApplicable: string;

  constructor() { }

}
